import { CircularProgress } from "@material-ui/core";
import React, { useCallback, useEffect, useState, useRef } from "react";
import { Table, Tooltip, OverlayTrigger, Modal, Button } from "react-bootstrap";
import SVG from "react-inlinesvg";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";
import axios from "axios";
import Checkbox from "../../../../components/Checkbox";
import { useIsAccessAllow } from "../../../users/redux";
import Select from "react-select";
import "../../../cold_leads/pages/cold_leads_detail/modernTable.scss";
import ContactCallDetailsModal from "../../components/ContactCallDetailsModal";
import {
  contactUsAction,
  deleteContactUsAsync,
  deletedSelectedContactsUs,
  getAllContactUsAsync,
  updateContactLeadTypeInListAsync,
} from "../../redux";
import CallDetailsButtonWithStatus from "../../../../components/CallDetailsButtonWithStatus";
import { getFailureLabel } from "../../../../utils/callFailure.util";
import { getSuccessDescriptor } from "../../../../utils/callSuccess.util";


const ContactUsTable = () => {
  const history = useHistory();
  const { pageType: currentPageType } = useParams();
  const [checkedVal, setCheckedVal] = useState(false);
  const [checkIds, setCheckIds] = useState([]);
  const prevTypeRef = useRef(null);
  let type = currentPageType ? currentPageType : "all";
  const { isLoading, ContactList, skip, limit } = useSelector(
    (state) => state.contactUs,
    shallowEqual,
  );

  const [callStatusCache, setCallStatusCache] = useState({});
  const [isCallModalOpen, setIsCallModalOpen] = useState(false);
  const [callDetailsId, setCallDetailsId] = useState(null);
  const [isDeleteConfirmOpen, setIsDeleteConfirmOpen] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState(null); // store contact or "bulk"
  const {
    searchBy,
    searchText,
    audioType,
    leadType,
    refreshContactList,
    callOutcomeFilter,
  } = useSelector((state) => state.contactUs, shallowEqual);

  const pageSizeOptions = [
    { value: 50, label: "50" },
    { value: 100, label: "100" },
    { value: 150, label: "150" },
    { value: 200, label: "200" },
  ];

  const defaultPageSize =
    pageSizeOptions.find((option) => option.value === limit) ||
    pageSizeOptions[0];

  const changePageSize = (option) => {
    dispatch(contactUsAction.setLimit(option.value));
    dispatch(contactUsAction.setContactBatchNumber(0));
  };

  const dispatch = useDispatch();
  const onPageChange = (pageIndex) => {
    const nextPage = Math.max(0, pageIndex);
    dispatch(contactUsAction.setContactBatchNumber(nextPage));
  };

  const { adminBaseURL } = useSelector(
    (state) => state.environnment.environmentLists,
    shallowEqual,
  );

  // Load data when refreshContactList changes, type changes (route change), or on mount
  useEffect(() => {
    const isFirstMount = prevTypeRef.current === null;
    const typeChanged =
      prevTypeRef.current !== null && prevTypeRef.current !== type;

    // Fetch data when:
    // 1. refreshContactList is true (filter changes or initial mount)
    // 2. type/route changes (navigation to different page type)
    // 3. On first mount (to ensure data loads even if refreshContactList is somehow false)
    if (refreshContactList || typeChanged || isFirstMount) {
      // API function will get the latest leadType from Redux state
      dispatch(
        getAllContactUsAsync(
          searchBy,
          searchText,
          type,
          audioType,
          leadType || "all",
          callOutcomeFilter,
        ),
      );
    }

    // Update ref after checking
    prevTypeRef.current = type;
    // eslint-disable-next-line
  }, [refreshContactList, type, callOutcomeFilter, skip, limit]);

  const onViewClick = (data) => {
    history.push(`/contact-us/view-contact-us/${data?._id}`);
  };
  const onCallDetailsClick = (data) => {
    window.open(`/contact-us/call-details/${data?._id}`, "_blank");
  };

  // Helper functions for call status (aligned with cold leads)
  const formatTime = useCallback((ts) => {
    if (!ts) return "-";
    try {
      return new Date(ts).toLocaleTimeString(undefined, {
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
      });
    } catch (e) {
      return "-";
    }
  }, []);

  const formatDate = useCallback((ts) => {
    if (!ts) return "-";
    try {
      const d = new Date(ts);
      const dd = String(d.getDate()).padStart(2, "0");
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      const yyyy = d.getFullYear();
      return `${dd}/${mm}/${yyyy}`;
    } catch (e) {
      return "-";
    }
  }, []);

  // const normalizeStatusText = useCallback((value) => {
  //   if (!value || typeof value !== "string") return "";
  //   const cleaned = value
  //     .replace(/[_-]+/g, " ")
  //     .replace(/\s+/g, " ")
  //     .trim();
  //   if (!cleaned) return "";
  //   return cleaned
  //     .split(" ")
  //     .map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
  //     .join(" ");
  // }, []);

  // const getSuccessDescriptor = useCallback(
  //   (item) => {
  //     if (!item) return "Call";
  //     if (
  //       item.type === "call_initiation_failure" &&
  //       (item.failure_reason === "no-answer" ||
  //         item.failure_reason === "no answer")
  //     ) {
  //       return "Not Concluded";
  //     }
  //     if (item.voicemail_detection === true) return "Not Concluded";
  //     if (item.elevenlabs_analysis) {
  //       try {
  //         const analysis =
  //           typeof item.elevenlabs_analysis === "string"
  //             ? JSON.parse(item.elevenlabs_analysis)
  //             : item.elevenlabs_analysis;
  //         const callScheduleEval =
  //           analysis?.evaluation_criteria_results?.call_schedule_evaluation
  //             ?.result;
  //         const clientEngagementEval =
  //           analysis?.evaluation_criteria_results?.client_engagement_evaluation
  //             ?.result;
  //         if (callScheduleEval && clientEngagementEval) {
  //           const normalizedCallSchedule = String(callScheduleEval)
  //             .trim()
  //             .toLowerCase();
  //           const normalizedClientEngagement = String(clientEngagementEval)
  //             .trim()
  //             .toLowerCase();
  //           if (
  //             normalizedCallSchedule === "success" &&
  //             normalizedClientEngagement === "success"
  //           )
  //             return "Call Concluded";
  //           if (
  //             normalizedCallSchedule === "failure" &&
  //             normalizedClientEngagement === "failure"
  //           )
  //             return "Not Interested";
  //           if (
  //             normalizedCallSchedule === "failure" &&
  //             normalizedClientEngagement === "success"
  //           )
  //             return "Not Interested";
  //           return "Not Concluded";
  //         }
  //       } catch (error) { }
  //     }
  //     const message = normalizeStatusText(
  //       item?.elevenlabs_message ||
  //       item?.status_message ||
  //       item?.call_status_message,
  //     );
  //     if (message) return message;
  //     const typeDescriptor = normalizeStatusText(
  //       item?.type || item?.callOutcome || item?.status,
  //     );
  //     if (typeDescriptor) return typeDescriptor;
  //     return "Call";
  //   },
  //   [normalizeStatusText],
  // );

  const isFailureRecord = useCallback((item) => {
    return (
      item &&
      typeof item.type === "string" &&
      (item.type === "call_initiation_failure" || item.type === "call_not_connect") &&
      (String(item.call_initiation_failure || "").trim() !== "" || item.type === "call_not_connect")
    );
  }, []);

  const getCallOutcome = useCallback((item, status, isFailure) => {
    if (!item || !status) return "-";
    if (item.elevenlabs_call_outcome_status)
      return item.elevenlabs_call_outcome_status;
    if (isFailure) return "Not Concluded";
    return item.elevenlabs_call_outcome_status;
  }, []);

  const getCallStatus = useCallback(
    async (lead) => {
      if (!lead?._id) return null;
      const contactId = lead._id;
      if (callStatusCache[contactId]) return callStatusCache[contactId];
      try {
        const items =
          lead.call_ai || lead.callAi || lead.callRecords || [];
        const latestCall =
          Array.isArray(items) && items.length > 0
            ? items[items.length - 1]
            : null;
        if (latestCall) {
          const isFailure = isFailureRecord(latestCall);
          const status = isFailure
            ? getFailureLabel(latestCall)
            : getSuccessDescriptor(latestCall);
          const outcome = getCallOutcome(latestCall, status, isFailure);
          const statusData = {
            status,
            outcome,
            date: formatDate(latestCall?.createdOn),
            time: formatTime(latestCall?.createdOn),
            isFailure,
          };
          setCallStatusCache((prev) => ({
            ...prev,
            [contactId]: statusData,
          }));
          return statusData;
        }
      } catch (error) { }
      return null;
    },
    [
      callStatusCache,
      formatDate,
      formatTime,
      getFailureLabel,
      getCallOutcome,
      isFailureRecord,
    ],
  );

  const onNameClick = (data) => {
    if (!data?._id) return;
    setCallDetailsId(data._id);
    setIsCallModalOpen(true);
  };
  const closeCallDetailsModal = () => {
    setIsCallModalOpen(false);
  };
  const onDeleteClick = (data) => {
    if (!data?._id) return;
    setDeleteTarget({ type: "single", contactId: data._id });
    setIsDeleteConfirmOpen(true);
  };

  const handleDeleteConfirm = () => {
    if (!deleteTarget) return;

    if (deleteTarget.type === "single" && deleteTarget.contactId) {
      dispatch(deleteContactUsAsync(deleteTarget.contactId));
      dispatch(
        getAllContactUsAsync(
          searchBy,
          searchText,
          type,
          audioType,
          leadType,
          callOutcomeFilter,
        ),
      );
    } else if (deleteTarget.type === "bulk" && checkIds.length) {
      dispatch(deletedSelectedContactsUs(checkIds));
      setCheckedVal(false);
      setCheckIds([]);
      dispatch(
        getAllContactUsAsync(
          searchBy,
          searchText,
          type,
          audioType,
          leadType,
          callOutcomeFilter,
        ),
      );
    }

    setIsDeleteConfirmOpen(false);
    setDeleteTarget(null);
  };

  const handleDeleteCancel = () => {
    setIsDeleteConfirmOpen(false);
    setDeleteTarget(null);
  };

  const allChecked = (e) => {
    setCheckedVal(!checkedVal);
    setCheckIds(ContactList.records.map((li) => li._id));
    if (checkedVal) {
      setCheckIds([]);
    }
  };

  const oneChecked = (e) => {
    const { id, checked } = e.target;
    setCheckIds([...checkIds, id]);
    if (!checked) {
      setCheckIds(checkIds.filter((item) => item !== id));
    }
  };

  const deleteSelectedContact = () => {
    if (!checkIds.length) return;
    setDeleteTarget({ type: "bulk" });
    setIsDeleteConfirmOpen(true);
  };

  const isViewAllow = useIsAccessAllow("contact_us.view");
  const isDeteleAllow = useIsAccessAllow("contact_us.delete");
  const isMultipleDeteleAllow = useIsAccessAllow("contact_us.multiple_delete");
  const isCallDetailsAllow = useIsAccessAllow("contact_us.view");

  const getLeadTypeStyle = (leadType) => {
    switch (leadType?.toLowerCase()) {
      case "genuine":
        return {
          color: "#28a745",
          fontWeight: "500",
        };
      case "promotional":
        return {
          color: "#007bff",
          fontWeight: "500",
        };
      case "spam":
        return {
          color: "#dc3545",
          fontWeight: "500",
        };
      default:
        return {
          color: "#6c757d",
          fontWeight: "500",
        };
    }
  };

  const formatLeadType = (leadType) => {
    if (!leadType) return "-";
    const formatted =
      leadType.charAt(0).toUpperCase() + leadType.slice(1).toLowerCase();
    return formatted;
  };

  const leadTypeOptions = ["Genuine", "Promotional", "Spam"];
  const [savingLeadTypeId, setSavingLeadTypeId] = useState(null);

  const handleLeadTypeSelect = async (id, value) => {
    setSavingLeadTypeId(id);
    try {
      await dispatch(
        updateContactLeadTypeInListAsync(id, value === "" ? null : value),
      );
    } catch (error) {
      // Error snackbar already dispatched inside updateContactLeadTypeInListAsync
    } finally {
      setSavingLeadTypeId(null);
    }
  };

  const totalRecords = ContactList.recordsTotal || 0;
  const totalPages = Math.ceil(totalRecords / (limit || 1));
  const currentPage = skip + 1;

  return (
    <>
      <div
        className="px-6 pt-0 dash_wt_bx pb-0 ovflhddn loader-display-position"
        style={{
          background: "#ffffff",
          borderRadius: "12px",
          padding: "24px",
          display: "flex",
          flexDirection: "column",
          height: "calc(100vh - 180px)",
          minHeight: "600px",
        }}
      >
        <div
          className="tblmrgn mt-0"
          style={{
            display: "flex",
            flexDirection: "column",
            flex: "1 1 auto",
            minHeight: 0,
          }}
        >
          {isMultipleDeteleAllow && (
            <div className="mt-4 mb-4" style={{ flex: "0 0 auto" }}>
              <div style={{ float: "right" }}>
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip id="bulk-delete-tooltip">Delete</Tooltip>}
                >
                  <button
                    type="button"
                    className="custom-action-button button-danger"
                    disabled={checkIds.length === 0}
                    onClick={deleteSelectedContact}
                    style={{ minWidth: "40px", padding: "8px" }}
                  >
                    <span className="svg-icon" style={{ color: "#ffffff" }}>
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/custom/delete.svg",
                        )}
                        height={20}
                        width={20}
                      />
                    </span>
                  </button>
                </OverlayTrigger>
              </div>
            </div>
          )}
          <div
            className="table-container-wrapper"
            style={{ flex: "1 1 auto", minHeight: 0 }}
          >
            <div className="table-scroll-container">
              <Table hover className="mb-0 modern-table">
                <thead>
                  <tr>
                    {isMultipleDeteleAllow && (
                      <th
                        style={{
                          width: "50px",
                          minWidth: "50px",
                          maxWidth: "50px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        <label className="custom-checkbox-wrapper">
                          <Checkbox
                            type="checkbox"
                            name="checkAll"
                            id="checkAll"
                            handleClick={allChecked}
                            isChecked={checkedVal}
                          />
                          <span className="custom-checkbox"></span>
                        </label>
                      </th>
                    )}
                    <th
                      style={{
                        width: "70px",
                        minWidth: "70px",
                        maxWidth: "70px",
                        whiteSpace: "nowrap",
                      }}
                    >
                      Sr No.
                    </th>
                    <th style={{ whiteSpace: "nowrap" }}>WEB ID</th>
                    <th style={{ whiteSpace: "nowrap" }}>Page Name</th>
                    <th style={{ whiteSpace: "nowrap" }}>Name</th>
                    <th style={{ whiteSpace: "nowrap" }}>Country</th>
                    <th style={{ whiteSpace: "nowrap" }}>Email</th>
                    <th style={{ whiteSpace: "nowrap" }}>
                      Project Requirement
                    </th>
                    <th style={{ whiteSpace: "nowrap" }}>Created On</th>
                    <th style={{ whiteSpace: "nowrap" }}>Lead Type</th>
                    <th
                      style={{
                        whiteSpace: "nowrap",
                        width: "200px",
                        minWidth: "200px",
                      }}
                    >
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {!isLoading &&
                    ContactList.records &&
                    ContactList.records.length ? (
                    ContactList.records.map((ContactLists, index) => (
                      <tr key={index}>
                        {isMultipleDeteleAllow && (
                          <td
                            style={{
                              width: "50px",
                              minWidth: "50px",
                              maxWidth: "50px",
                              whiteSpace: "nowrap",
                            }}
                          >
                            <label className="custom-checkbox-wrapper">
                              <Checkbox
                                type="checkbox"
                                name={ContactLists._id}
                                id={ContactLists._id}
                                handleClick={oneChecked}
                                isChecked={checkIds.includes(ContactLists._id)}
                              />
                              <span className="custom-checkbox"></span>
                            </label>
                          </td>
                        )}
                        <td
                          style={{
                            width: "70px",
                            minWidth: "70px",
                            maxWidth: "70px",
                            whiteSpace: "nowrap",
                          }}
                        >
                          <span>{skip * limit + (index + 1)}</span>
                        </td>
                        <td style={{ whiteSpace: "nowrap" }}>
                          <span>{ContactLists.web_id}</span>
                        </td>
                        <td style={{ whiteSpace: "nowrap" }}>
                          <span>{ContactLists.pageName}</span>
                        </td>
                        <td style={{ whiteSpace: "nowrap" }}>
                          {isCallDetailsAllow &&
                            ContactLists &&
                            ContactLists.elevenlabs_call_ai_id &&
                            ContactLists.elevenlabs_conversation_id ? (
                            <button
                              type="button"
                              onClick={() => onNameClick(ContactLists)}
                              className="profile-name clickable-name"
                              style={{
                                background: "none",
                                border: "none",
                                padding: 0,
                                margin: 0,
                                color: "#3b82f6",
                                textDecoration: "underline",
                                cursor: "pointer",
                                fontSize: "inherit",
                                fontWeight: "inherit",
                              }}
                            >
                              {ContactLists.name}
                            </button>
                          ) : (
                            <span className="profile-name">
                              {ContactLists.name}
                            </span>
                          )}
                        </td>
                        <td style={{ whiteSpace: "nowrap" }}>
                          <span>{ContactLists.countryName || "-"}</span>
                        </td>
                        <td style={{ whiteSpace: "nowrap" }}>
                          <div
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              gap: "6px",
                            }}
                          >
                            <span>{ContactLists.email || "-"}</span>
                          </div>
                          {ContactLists.contactNumber && (
                            <div
                              style={{
                                fontSize: 12,
                                color: "#6b7280",
                                marginTop: "2px",
                              }}
                            >
                              {ContactLists.contactNumber}
                            </div>
                          )}
                        </td>
                        <td style={{ whiteSpace: "nowrap" }}>
                          {ContactLists.pro_requirements ? (
                            <OverlayTrigger
                              placement="top"
                              overlay={
                                <Tooltip
                                  id={`contact-req-${ContactLists?._id ||
                                    index}`}
                                >
                                  {ContactLists.pro_requirements}
                                </Tooltip>
                              }
                            >
                              <span
                                style={{
                                  display: "inline-block",
                                  maxWidth: "300px",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                  verticalAlign: "middle",
                                  cursor: "help",
                                }}
                              >
                                {ContactLists.pro_requirements}
                              </span>
                            </OverlayTrigger>
                          ) : (
                            <span>-</span>
                          )}
                        </td>
                        <td style={{ whiteSpace: "nowrap" }}>
                          <span>
                            {ContactLists?.createdOn
                              ? (() => {
                                const d = new Date(ContactLists.createdOn);
                                const dd = String(d.getDate()).padStart(
                                  2,
                                  "0",
                                );
                                const mm = String(d.getMonth() + 1).padStart(
                                  2,
                                  "0",
                                );
                                const yy = String(d.getFullYear()).slice(-2);
                                const time = d.toLocaleTimeString(undefined, {
                                  hour: "2-digit",
                                  minute: "2-digit",
                                  hour12: true,
                                });
                                return `${dd}/${mm}/${yy} ${time}`;
                              })()
                              : "-"}
                          </span>
                        </td>
                        <td style={{ whiteSpace: "nowrap" }}>
                          {isViewAllow ? (
                            <select
                              className="form-control re_inputRouded"
                              style={{
                                ...getLeadTypeStyle(ContactLists.leadType),
                                width: "auto",
                                minWidth: "130px",
                                padding: "4px 8px",
                                height: "auto",
                              }}
                              value={ContactLists.leadType || ""}
                              disabled={savingLeadTypeId === ContactLists._id}
                              onChange={(e) =>
                                handleLeadTypeSelect(
                                  ContactLists._id,
                                  e.target.value,
                                )
                              }
                            >
                              {!ContactLists.leadType && (
                                <option value="" disabled hidden>
                                  -
                                </option>
                              )}
                              {leadTypeOptions.map((option) => (
                                <option
                                  key={option}
                                  value={option}
                                  style={getLeadTypeStyle(option)}
                                >
                                  {option}
                                </option>
                              ))}
                            </select>
                          ) : ContactLists.leadType ? (
                            <span
                              style={getLeadTypeStyle(ContactLists.leadType)}
                            >
                              {formatLeadType(ContactLists.leadType)}
                            </span>
                          ) : (
                            <span>-</span>
                          )}
                        </td>
                        <td
                          style={{
                            whiteSpace: "nowrap",
                            textAlign: "left",
                            width: "200px",
                            minWidth: "200px",
                          }}
                        >
                          <div className="inline-actions">
                            {isCallDetailsAllow &&
                              ContactLists &&
                              ContactLists.elevenlabs_call_ai_id &&
                              ContactLists.elevenlabs_conversation_id && (
                                <CallDetailsButtonWithStatus
                                  lead={ContactLists}
                                  onCallDetailsPageClick={onCallDetailsClick}
                                  getCallStatus={getCallStatus}
                                />
                              )}
                            {isViewAllow && (
                              <OverlayTrigger
                                placement="top"
                                overlay={
                                  <Tooltip
                                    id={`view-tooltip-${ContactLists._id ||
                                      index}`}
                                  >
                                    View Details
                                  </Tooltip>
                                }
                              >
                                <button
                                  type="button"
                                  className="inline-action-btn"
                                  onClick={() => onViewClick(ContactLists)}
                                >
                                  <span className="svg-icon svg-icon-primary">
                                    <SVG
                                      src={toAbsoluteUrl(
                                        "/media/svg/icons/custom/eye.svg",
                                      )}
                                    />
                                  </span>
                                </button>
                              </OverlayTrigger>
                            )}
                            {isDeteleAllow && (
                              <OverlayTrigger
                                placement="top"
                                overlay={
                                  <Tooltip
                                    id={`delete-tooltip-${ContactLists._id ||
                                      index}`}
                                  >
                                    Delete
                                  </Tooltip>
                                }
                              >
                                <button
                                  type="button"
                                  className="inline-action-btn danger"
                                  onClick={() => onDeleteClick(ContactLists)}
                                >
                                  <span className="svg-icon svg-icon-danger">
                                    <SVG
                                      src={toAbsoluteUrl(
                                        "/media/svg/icons/custom/delete.svg",
                                      )}
                                      height={20}
                                      width={20}
                                    />
                                  </span>
                                </button>
                              </OverlayTrigger>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan={isMultipleDeteleAllow ? 11 : 10}
                        className="text-center"
                      >
                        {isLoading ? "Loading..." : "No Record Found"}
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
          </div>
          {!isLoading && (
            <div className="modern-pagination" style={{ flex: "0 0 auto" }}>
              <div
                className="pagination-info"
                style={{ display: "flex", alignItems: "center", gap: "12px" }}
              >
                <div
                  style={{ display: "flex", alignItems: "center", gap: "8px" }}
                >
                  <span style={{ fontSize: "14px", color: "#6b7280" }}>
                    Show
                  </span>
                  <Select
                    classNamePrefix="react-select"
                    value={defaultPageSize}
                    options={pageSizeOptions}
                    onChange={changePageSize}
                    isSearchable={false}
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    styles={{
                      container: (base) => ({
                        ...base,
                        width: 90,
                      }),
                      control: (base, state) => ({
                        ...base,
                        minHeight: 36,
                        height: 36,
                        borderColor: state.isFocused ? "#6993FF" : "#d1d5db",
                        boxShadow: state.isFocused
                          ? "0 0 0 3px rgba(105, 147, 255, 0.1)"
                          : "none",
                        "&:hover": {
                          borderColor: "#6993FF",
                        },
                      }),
                      valueContainer: (base) => ({
                        ...base,
                        padding: "0 10px",
                        height: 36,
                        display: "flex",
                        alignItems: "center",
                      }),
                      singleValue: (base) => ({
                        ...base,
                        fontSize: 13,
                        fontWeight: 500,
                        color: "#111827",
                      }),
                      indicatorSeparator: () => ({ display: "none" }),
                      dropdownIndicator: (base, state) => ({
                        ...base,
                        padding: 6,
                        color: state.isFocused ? "#6993FF" : "#6b7280",
                      }),
                      option: (base, state) => ({
                        ...base,
                        fontSize: 13,
                        padding: "8px 10px",
                        backgroundColor: state.isSelected
                          ? "#6993FF"
                          : state.isFocused
                            ? "#f3f4f6"
                            : "#fff",
                        color: state.isSelected ? "#fff" : "#111827",
                      }),
                      menuPortal: (base) => ({
                        ...base,
                        zIndex: 9999,
                      }),
                    }}
                  />
                </div>
                Showing{" "}
                {ContactList.records && ContactList.records.length
                  ? skip * limit + 1
                  : 0}{" "}
                to{" "}
                {ContactList.records && ContactList.records.length
                  ? Math.min(
                    skip * limit + ContactList.records.length,
                    totalRecords,
                  )
                  : 0}{" "}
                of {totalRecords} entries
              </div>
              <div className="pagination-controls">
                <button
                  className="page-btn"
                  onClick={() => onPageChange(skip - 1)}
                  disabled={skip === 0}
                >
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="currentColor"
                  >
                    <path
                      d="M10 12L6 8l4-4"
                      stroke="currentColor"
                      strokeWidth="2"
                      fill="none"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
                {(() => {
                  const pages = [];
                  if (totalPages > 0) pages.push(1);
                  for (
                    let i = Math.max(2, currentPage - 1);
                    i <= Math.min(totalPages - 1, currentPage + 1);
                    i++
                  ) {
                    if (!pages.includes(i)) pages.push(i);
                  }
                  if (totalPages > 1 && !pages.includes(totalPages))
                    pages.push(totalPages);
                  return pages.map((page, idx) => {
                    const showEllipsisBefore =
                      idx > 0 && page - pages[idx - 1] > 1;
                    return (
                      <React.Fragment key={page}>
                        {showEllipsisBefore && (
                          <span style={{ padding: "0 4px" }}>...</span>
                        )}
                        <button
                          className={`page-btn ${currentPage === page ? "active" : ""
                            }`}
                          onClick={() => onPageChange(page - 1)}
                        >
                          {page}
                        </button>
                      </React.Fragment>
                    );
                  });
                })()}
                <button
                  className="page-btn"
                  onClick={() => onPageChange(skip + 1)}
                  disabled={(skip + 1) * limit >= totalRecords}
                >
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="currentColor"
                  >
                    <path
                      d="M6 12l4-4-4-4"
                      stroke="currentColor"
                      strokeWidth="2"
                      fill="none"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
              </div>
            </div>
          )}
          {isLoading && (
            <div style={{ flex: "0 0 auto" }}>
              <div style={{ justifyContent: "center" }} className="text-center">
                <div className="basic-verification-loader text-center">
                  <CircularProgress />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <ContactCallDetailsModal
        show={isCallModalOpen}
        onHide={closeCallDetailsModal}
        contactId={callDetailsId}
      />
      <Modal
        show={isDeleteConfirmOpen}
        onHide={handleDeleteCancel}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {deleteTarget?.type === "bulk"
            ? `Are you sure you want to delete ${checkIds.length} selected contact(s)?`
            : "Are you sure you want to delete this contact?"}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleDeleteCancel}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleDeleteConfirm}>
            OK
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ContactUsTable;
